import { Status, StatusRootProps } from '@chakra-ui/react';

type VStatusProps = StatusRootProps;

const VStatus = ({ children, size = 'sm', ...props }: VStatusProps) => (
  <Status.Root size={size} {...props}>
    <Status.Indicator />
    {children}
  </Status.Root>
);

export default VStatus;
export type { VStatusProps };
